<template>
	<section class=" bg-main">
		<div class="py-12"></div>
		<div class="vx-row justify-center m-0">
			<div class="vx-col w-5/6 md:w-3/4 lg:w-5/6">
				<section class="vx-row items-center">
					<div class="vx-col w-full lg:w-1/2 xl:w-2/3 flex items-center mb-4 lg:mb-0">
						<img src="/assets/images/footer/logozx.svg" alt="" class="w-24 xl:w-48 mr-4" />
						<h1 class="text-white">Selamat Datang di ZX!</h1>
					</div>
					<div class="vx-col w-full lg:w-1/2 xl:w-1/3">
						<vx-card class="p-4">
							<header class="mb-4">
								<h3 class="text-center"><strong>Login</strong></h3>
							</header>
							<section>
								<div class="my-2">
									<vs-alert color="danger" v-if="error"><strong> {{ error }} </strong></vs-alert>	
								</div>

								<div class="mb-6">
									<strong class="block mb-2">Email</strong>
									<vs-input
										:class="!errors.has('email') ? 'w-full mb-4' : 'w-full'"
										placeholder="Email" 
										v-model="email"
										@keyup.enter="login"
										val-icon-danger="icon-x"
				                		val-icon-pack="feather"
										name="email"
										v-validate="'required|email'"
										:danger="errors.has('email')"
									/>
									<span class="text-danger text-sm" v-show="errors.has('email')">
										<strong>{{ errors.first('email') }}</strong>
									</span>
								</div>
								<div class="mb-6">
									<div class="flex justify-between mb-2">
										<strong class="block">Kata Sandi</strong>
										<router-link to="forgot-password">
											Lupa kata sandi?
										</router-link>
									</div>
									<section class="relative">
										<vs-input
											@keyup.enter="login"
											:type="currentTypePassword" 
											class="w-full" 
											:class="!errors.has('password') ? 'mb-4' : ''"
											placeholder="Password" 
											val-icon-danger="icon-x"
											val-icon-pack="feather"
											name="password"
											v-model="password"
											v-validate="'required|min:3'"
											:danger="errors.has('password')"
										/>
										<div class="eye absolute px-4 pt-2 top-0 right-0">
											<section v-if="showPassword">
												<a href="#" class="cursor-pointer" @click.prevent="showPassword = false">
													<feather-icon icon="EyeOffIcon"></feather-icon>
												</a>
											</section>
											<section v-else>
												<a href="#" class="cursor-pointer" @click.prevent="showPassword = true">
													<feather-icon icon="EyeIcon"></feather-icon>
												</a>
											</section>
										</div>
									</section>
									<span class="text-danger text-sm" v-show="errors.has('password')">
										<strong>{{ errors.first('password') }}</strong>
									</span>
								</div>
								<div class="mb-6">
									<div class="flex">
										<vs-checkbox class="mr-2" />
										<span class="text-primary">Ingat Saya</span>
									</div>
								</div>
								<vs-button class="w-full mb-6" @click.prevent="login">
									Masuk
								</vs-button>
								<router-link to="register" class="block text-center">
									<strong class="text-primary">
										Belum punya akun? Buat sekarang
									</strong>
								</router-link>
							</section>
						</vx-card>
					</div>
				</section>
			</div>
					
		</div>
		<div class="py-12"></div>
	</section>
		
</template>
<script>
import { Validator } from 'vee-validate'

const allowedSlug = ['sahabatzx', 'user']

const dict = {
	  custom: {
	    email: {
	      required: 'Harap masukan email',
	      email: 'Harap masukan email yang valid'
	    },
	    password: {
	    	required: 'Harap masukan password',
	    	min: 'Password minimal 6 karakter'
	    }
	  }
}

// register custom messages
Validator.localize('en', dict)

export default {
  data: () => ({
    email: null,
    password: null,
    error: null,
	showPassword: false,
	currentTypePassword: 'password'
  }),
  watch: {
	showPassword(val) {
		if(val) {
			this.currentTypePassword = 'text';
		}
		else {
			this.currentTypePassword = 'password';
		}
	}
  },
  methods: {
    login () {
      this.$validator.validateAll().then(res => {
        if (res) {

          this.$vs.loading()

          const fd = new FormData()

          fd.append('email', this.email)
          fd.append('password', this.password)

          this.$store.dispatch('auth/login', fd)
            .then(profile => {

              this.$vs.loading.close()

              if(!profile.level) { // if level null || user not verify
              	this.$store.dispatch('auth/logout')
              	.then(() => {
              		this.$vs.notify({
              			title: 'Oops',
              			text: 'Harap melakukan verifikasi akun',
              			color: 'warning',
              			position: 'top-right'
              		})

              		return false
              	})
              }

              // if level not in allowedSlug
              if(!allowedSlug.includes(profile.level.slug)) {
              	this.$store.dispatch('auth/logout')
              	.then(() => {
              		this.$vs.notify({
	              		title: 'Peringatan',
	              		text: 'Anda tidak diperbolehkan',
	              		color: 'danger',
	              		position: 'top-right'
	              	})
              	})

              	return false
              }

              if (this.$route.query.to) {
                window.location = this.$route.query.to
              } else {
                window.location.reload()
              }


            })
            .catch(e => {
              this.$vs.loading.close()
			  if(e.response) {
				  const error = e.response.data // { message: 'Data Error' } 
				  console.error(e.response.data)
				  if(e.response.data.message) {
					  alert(e.response.data.message)
				  }
			  }
            })

        }
      })
    }
  }
}
</script>
<style>
	.bg-main {
		background-image: url('/assets/images/footer/bg.svg');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>